<template>
  <div class="more-table-actions" :class="locationMenu">
    <div v-if="this.userDetails.isAdmin == 1" class="action-option" @click="removeItem()">
      <p>Delete</p>
      <BaseIcon name="times-circle" class="icon red" />
    </div>
    <div v-else class="action-option">
      <p>No actions</p>
    </div>
  </div>
</template>

<script>
import BaseIcon from "@/components/base/Icon";

export default {
  components : {
    BaseIcon, 
  },
  computed : {
    userDetails() {
      return this.$store.state.userDetails
    }
  },
  props: {
    locationMenu: ''
  },
  data() {
    return {
    }
  },
  methods: {
    removeItem() {
      this.$emit('deleteRow')
    },
  }
}
</script>

<style lang="scss" scoped>
  @import "@/style/base.scss";
  @import "@/style/components/tables.scss";
  @import "@/style/components/active.scss";

  .more-table-actions {
    position: absolute;
    z-index: 10000;
    right: 2%;
    width: 120px;
    max-height: 160px;
    border-radius: 6px;
    background: #fff;
    box-shadow: 0px 1px 6px rgba(0, 0, 0, 0.16);

    &.top{
      top: -20px;
    }

    &.bottom{
      top: 40px;
    }

    .action-option {
      padding: 10px 16px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      align-content: center;

      p {
        font-size: 12px;
        text-align: left;
        color: #5f5f5f;
        user-select: none;
      }
    }
  }
</style>
